"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DndArrows = function DndArrows() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dndArrows
  }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
};
var _default = exports["default"] = DndArrows;